import { render, staticRenderFns } from "./ConteosAbiertosTable.vue?vue&type=template&id=2d2ba0b0&scoped=true"
import script from "./ConteosAbiertosTable.vue?vue&type=script&lang=js"
export * from "./ConteosAbiertosTable.vue?vue&type=script&lang=js"
import style0 from "./ConteosAbiertosTable.vue?vue&type=style&index=0&id=2d2ba0b0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d2ba0b0",
  null
  
)

export default component.exports